import { useLocation } from 'react-router-dom';

const useIsRouteActive = (path: string, allowSubRoutes = true) => {
    const { pathname } = useLocation();

    return (allowSubRoutes && pathname.startsWith(path)) || path === pathname;
};

export default useIsRouteActive;
